export default "__VITE_ASSET__gcTo8z7eTh1bxVn0WgfmDA__"